import React from 'react'
import { Grid } from '@material-ui/core'
import { useRouteMatch } from 'react-router-dom'
import Divider from '../../../../components/atoms/Divider'
import PageHeading from '../common/PageHeading'
import PageLayout from '../common/PageLayout'
import SydLinkButton from '../../../../components/commonDesign/LinkButton'
import UserScheduleList from './UserScheduleList'

function SchedulesHome () {
  const { path } = useRouteMatch()

  return (
    <PageLayout variant='constrained'>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageHeading title='Schedules'>
            <SydLinkButton size='md' variant='outline' icon='add' to={`${path}/new`}>New</SydLinkButton>
          </PageHeading>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <UserScheduleList />
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default SchedulesHome
